import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { differSocialsLinks } from '../../api/utils'
import { socialsDomains } from '../../constants/socialIcons'
import SocialsAndTags from '../SocialsAndTags'
import WysiwygContent from '../WysiwygContent'
import { ExpertsList } from '../../styles/stageStyles'
import SocialIcons from '../SocialIcons'
import { withTranslation } from '../../i18n'
import { DescriptionDiv } from './styles'

class DescriptionSection extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    className: PropTypes.string,
    header: PropTypes.string.isRequired,
    subHeader: PropTypes.string,
    description: PropTypes.string,
    subDescription: PropTypes.string,
    wysiwygDescription: PropTypes.string,
    links: PropTypes.arrayOf(String).isRequired,
    experts: PropTypes.arrayOf(Object),
    tags: PropTypes.arrayOf(String).isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    partner: PropTypes.instanceOf(Object),
    width: PropTypes.number.isRequired
  }

  static defaultProps = {
    subHeader: null,
    description: '',
    subDescription: null,
    wysiwygDescription: null,
    className: undefined,
    children: undefined,
    experts: [],
    partner: null
  }


  render() {
    const {
      header, subHeader, description, subDescription, wysiwygDescription, links, tags, className, children, partner, width, experts, t
    } = this.props
    const { others, socials } = differSocialsLinks(links, socialsDomains)

    return (
      <DescriptionDiv className={className}>
        <div className="infoWrap">
          <h1 className="descriptionHeader">
            {header}
          </h1>
          {subHeader && <h2 className="descriptionSubHeader">{subHeader}</h2>}
          <SocialsAndTags others={others} socials={socials} width={width} />
          {wysiwygDescription && <WysiwygContent className="descriptionDiv" content={wysiwygDescription} />}
          {!wysiwygDescription && description && <div className="descriptionDiv">{description.trim()}</div>}
          {subHeader && subDescription &&
            <><h2 className="descriptionSubHeader">{t('artists:about_area')} «{subHeader}»</h2><div className="descriptionDiv">{subDescription.trim()}</div></>}
          {width > 1000
           && <SocialsAndTags tags={tags} width={width} partner={partner} />}
          {(width > 1000 && experts.length > 0) && (
            <ExpertsList>
              <h3>{t('artists:EXPERTS')}</h3>
              <div className="list">
                {experts.map((expert) => {
                  const { socials: expertSocials } = differSocialsLinks(expert.links, socialsDomains)
                  const [firstName, lastName] = expert.name.split(' ')
                  return (
                    <div className="expertDiv" key={firstName + lastName}>
                      <img src={expert.avatar} alt="" />
                      <span className="firstName">{firstName}</span>
                      {lastName && <span className="lastName">{lastName}</span>}
                      <SocialIcons socials={expertSocials} className="expertsSocials" />
                    </div>
                  )
                })}
              </div>
            </ExpertsList>
          )}
        </div>
        {children}
        {width <= 1000
        && (
        <div className="bottomInfo">
          <SocialsAndTags tags={tags} width={width} partner={partner} />
        </div>
        )}
        {(width <= 1000 && experts.length > 0) && (
          <ExpertsList>
            <h3>{t('artists:EXPERTS')}</h3>
            <div className="list">
              {experts.map((expert) => {
                const { socials: expertSocials } = differSocialsLinks(expert.links, socialsDomains)
                const [firstName, lastName] = expert.name.split(' ')
                return (
                  <div className="expertDiv" key={firstName + lastName}>
                    <img src={expert.avatar} alt="" />
                    <span className="firstName">{firstName}</span>
                    {lastName && <span className="lastName">{lastName}</span>}
                    <SocialIcons socials={expertSocials} className="expertsSocials" />
                  </div>
                )
              })}
            </div>
          </ExpertsList>
        )}
      </DescriptionDiv>
    )
  }
}

export default withTranslation(['artists'])(DescriptionSection)
